import { render } from "./SubscriberMessage.vue?vue&type=template&id=578d76f6&scoped=true"
import script from "./SubscriberMessage.vue?vue&type=script&lang=js"
export * from "./SubscriberMessage.vue?vue&type=script&lang=js"

import "./SubscriberMessage.vue?vue&type=style&index=0&id=578d76f6&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-578d76f6"]])

export default __exports__